<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormPlaceCategory
          :data="placeCategory"
          :loading="isQueryLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          @delete-place-category="deletePlaceCategory"
          @submit="formPlaceCategorySubmit"
          :language="language"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmPlaceCategoryRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import FormPlaceCategory from './form'
import ConfirmationDialog from '@/components/confirmation-dialog'
import eventCategories from '@/services/gql/types/EventCategories/queries/eventCategories.gql'
import createPlaceCategory from '@/services/gql/types/PlacesCategories/mutations/createPlaceCategory.gql'
import deletePlaceCategory from '@/services/gql/types/PlacesCategories/mutations/deletePlaceCategory.gql'
import updatePlaceCategory from '@/services/gql/types/PlacesCategories/mutations/updatePlaceCategory.gql'
import placeCategory from '@/services/gql/types/PlacesCategories/queries/placeCategory.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'

export default {
  name: 'PagePlaceCategory',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    FormPlaceCategory,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать категорию места' : 'Создать категорию места'
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      eventCategories: null,
      placeCategory: null
    }
  },
  computed: {
    isQueryLoading () {
      return (
        this.$apollo.queries.eventCategories.loading ||
        this.$apollo.queries.placeCategory.loading
      )
    },
    isMutationLoading () {
      return (
        this.$async.createPlaceCategory.$pending ||
        this.$async.deletePlaceCategory.$pending ||
        this.$async.updatePlaceCategory.$pending
      )
    }
  },
  methods: {
    async formPlaceCategorySubmit (placeCategoryPayload) {
      if (!this.id) {
        await this.createPlaceCategory(placeCategoryPayload)
      } else {
        await this.updatePlaceCategory(placeCategoryPayload)
      }
    },
    async deletePlaceCategory () {
      try {
        await this.$refs.confirmPlaceCategoryRemoving.open()
        await this.$async.deletePlaceCategory.$perform({
          id: Number(this.id)
        })
        this.$successMsg('Категория места удалена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении категории места с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-places-categories' })
      }
    },
    async updatePlaceCategory (data) {
      try {
        setTranslation(data, this.language)
        await this.$async.updatePlaceCategory.$perform({
          id: Number(this.id),
          data
        }, { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) })
        this.$successMsg('Категория места обновлена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении категории места')
      }
    },
    async createPlaceCategory (data) {
      // @TODO
      delete data.translations
      try {
        await this.$async.createPlaceCategory.$perform({
          data
        })
        this.$successMsg('Категория места создана')
        await this.$router.push({ name: 'page-places-categories' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании категории места')
      }
    }
  },
  apollo: {
    eventCategories: {
      query: eventCategories,
      fetchPolicy: 'network-only',
      pollInterval: 30000,
      variables: {
        where: {}
      }
    },
    placeCategory: {
      query: placeCategory,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () { return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } } }
    }
  },
  async: {
    createPlaceCategory (variables) {
      return this.$apollo.mutate({
        mutation: createPlaceCategory,
        variables
      })
    },
    deletePlaceCategory (variables) {
      return this.$apollo.mutate({
        mutation: deletePlaceCategory,
        variables
      })
    },
    updatePlaceCategory (variables, headers) {
      return this.$apollo.mutate({
        mutation: updatePlaceCategory,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
